document.addEventListener("DOMContentLoaded", async () => {
  const apps = document.querySelectorAll("#ingredient-app");
  const app = apps[apps.length - 1];

  // Worker API endpoint for ingredient requests
  const INGREDIENT_REQUEST_API = "https://ingredient-request-api.steve-556.workers.dev/request";

  if (!app) return;

  try {
    const response = await fetch(window.INGREDIENTS_URL);
    const ingredients = await response.json();

    const params = new URLSearchParams(window.location.search);
    const ingredientSlug = params.get("ingredient");

    if (ingredientSlug) {
      const ingredient = ingredients.find((i) => i.slug === ingredientSlug);

      if (ingredient) {
        renderIngredient(ingredient);
      } else {
        renderSearch();
      }
    } else {
      renderSearch();
    }

function renderSearch() {
  const searchHTML = `
    <div class="search-hero">
      <div class="search-hero-grid">
        <div class="search-left">
          <div class="search-eyebrow">
            Ingredient Intelligence
          </div>

          <h1 class="search-title">
            Understand What’s Really Inside Your Products.
          </h1>

          <div class="search-input-wrap">
            <input
              type="text"
              id="ingredient-search"
              class="ingredient-search-input"
              placeholder="Search ingredients..."
            />
            <p class="search-description">
              Search our ingredient database to understand what ingredients do,
              who they are best suited for, and how we evaluate them for
              skin compatibility and formulation quality.
            </p>

            <div class="ingredient-category-filters">
              <button type="button" class="ingredient-category-pill" data-category="our">
                Our ingredients
              </button>
              <button type="button" class="ingredient-category-pill" data-category="hydrator">
                Hydrators
              </button>
              <button type="button" class="ingredient-category-pill" data-category="soothing botanical">
                Soothing botanicals
              </button>
              <button type="button" class="ingredient-category-pill" data-category="emollient">
                Emollients
              </button>
              <button type="button" class="ingredient-category-pill" data-category="cleanser">
                Cleansers
              </button>
              <button type="button" class="ingredient-category-pill" data-category="preservative">
                Preservatives
              </button>
              <button type="button" class="ingredient-category-pill" data-category="fragrance">
                Fragrance
              </button>
              <button type="button" class="ingredient-category-pill" data-category="colorant">
                Colorants
              </button>
              <button type="button" class="ingredient-category-pill" data-category="solvent">
                Solvents
              </button>
              <button type="button" class="ingredient-category-pill" data-category="emulsifier">
                Emulsifiers
              </button>
              <button type="button" class="ingredient-category-pill" data-category="thickener">
                Thickeners
              </button>
              <button type="button" class="ingredient-category-pill" data-category="other">
                Other actives
              </button>
            </div>
          </div>
        </div>

        <div class="search-statuses">
          <p class="traffic-hint">
    Tap a color to filter the ingredient list by our safety rating.
  </p>

          <div class="status-row">
            <button
              type="button"
              class="ingredient-badge badge-green traffic-filter-pill"
              data-traffic="green"
            >
              Green
            </button>
            <div class="status-text">
              Well-supported and generally skin-friendly ingredients.
            </div>
          </div>

          <div class="status-row">
            <button
              type="button"
              class="ingredient-badge badge-amber traffic-filter-pill"
              data-traffic="amber"
            >
              Amber
            </button>
            <div class="status-text">
              Ingredients that may depend on concentration or skin sensitivity.
            </div>
          </div>

          <div class="status-row">
            <button
              type="button"
              class="ingredient-badge badge-red traffic-filter-pill"
              data-traffic="red"
            >
              Red
            </button>
            <div class="status-text">
              Ingredients we believe deserve additional caution or awareness.
            </div>
          </div>


        </div>
      </div>
    </div>

    <div id="ingredient-results"></div>
  `;

  app.innerHTML = searchHTML;

  const input = app.querySelector("#ingredient-search");
  const results = app.querySelector("#ingredient-results");
  const hero = app.querySelector(".search-hero");
  const categoryPills = app.querySelectorAll(".ingredient-category-pill");
  const trafficPills = app.querySelectorAll(".traffic-filter-pill");

  let activeTraffic = null;

  // Text search behaviour
  input.addEventListener("input", () => {
    const query = input.value.trim().toLowerCase();

    // Clear category and traffic filters when typing
    if (query.length > 0) {
      hero.classList.add("search-active");
      categoryPills.forEach(p => p.classList.remove("is-active"));
      activeTraffic = null;
      trafficPills.forEach(p => p.classList.remove("is-active"));
    } else {
      hero.classList.remove("search-active");
    }

    if (!query) {
      results.innerHTML = "";
      return;
    }

    const matches = ingredients.filter((ingredient) => {
      const nameMatch =
        ingredient.name &&
        ingredient.name.toLowerCase().includes(query);

      const aliasMatch =
        ingredient.aliases &&
        ingredient.aliases.some((alias) =>
          alias.toLowerCase().includes(query)
        );

      const categoryMatch =
        ingredient.category &&
        ingredient.category.toLowerCase().includes(query);

      return nameMatch || aliasMatch || categoryMatch;
    });

    if (!matches.length) {
      // No direct matches: show "not found" + inline request form
      results.innerHTML = `
        <div class="ingredient-empty">
          <h3>
            We haven’t added this ingredient yet.
          </h3>

          <p>
            Can’t find what you’re looking for? You can request this ingredient and we’ll research it for inclusion.
          </p>

          <button type="button" class="ingredient-request-toggle">
            Request this ingredient
          </button>

          <form class="ingredient-request-form" style="display:none; margin-top:16px;">
            <div style="margin-bottom:8px;">
              <label style="display:block; font-size:14px; margin-bottom:4px;">Ingredient name *</label>
              <input
                type="text"
                name="ingredient_name"
                class="ingredient-request-name"
                style="width:100%; padding:10px; border-radius:8px; border:1px solid #ddd;"
              />
            </div>

            <div style="margin-bottom:8px;">
              <label style="display:block; font-size:14px; margin-bottom:4px;">Product seen in (optional)</label>
              <input
                type="text"
                name="product_seen_in"
                class="ingredient-request-product"
                style="width:100%; padding:10px; border-radius:8px; border:1px solid #ddd;"
              />
            </div>

            <div style="margin-bottom:8px;">
              <label style="display:block; font-size:14px; margin-bottom:4px;">Email (optional)</label>
              <input
                type="email"
                name="email"
                class="ingredient-request-email"
                style="width:100%; padding:10px; border-radius:8px; border:1px solid #ddd;"
              />
            </div>

            <div style="margin-bottom:8px;">
              <label style="display:block; font-size:14px; margin-bottom:4px;">Notes (optional)</label>
              <textarea
                name="notes"
                class="ingredient-request-notes"
                style="width:100%; padding:10px; border-radius:8px; border:1px solid #ddd; min-height:80px;"
              ></textarea>
            </div>

            <button type="submit" class="ingredient-request-submit">
              Submit Request
            </button>

            <div class="ingredient-request-message" style="margin-top:8px; font-size:14px;"></div>
          </form>
        </div>
      `;

      // Prefill the ingredient name with the current query
      const nameInput = results.querySelector(".ingredient-request-name");
      if (nameInput) {
        nameInput.value = query;
      }

      // Toggle form visibility when button is clicked
      const toggleButton = results.querySelector(".ingredient-request-toggle");
      const form = results.querySelector(".ingredient-request-form");

      if (toggleButton && form) {
        toggleButton.addEventListener("click", () => {
          form.style.display = form.style.display === "none" ? "block" : "none";
        });
      }

      // Submit handler: send to Cloudflare Worker
      const formEl = results.querySelector(".ingredient-request-form");
      if (formEl) {
        formEl.addEventListener("submit", async (e) => {
          e.preventDefault();

          const messageBox = formEl.querySelector(".ingredient-request-message");
          if (messageBox) {
            messageBox.style.color = "#555";
            messageBox.textContent = "Submitting…";
          }

          const nameInput = formEl.querySelector(".ingredient-request-name");
          const productInput = formEl.querySelector(".ingredient-request-product");
          const emailInput = formEl.querySelector(".ingredient-request-email");
          const notesInput = formEl.querySelector(".ingredient-request-notes");

          const ingredientName = nameInput?.value.trim() || "";
          const productSeenIn = productInput?.value.trim() || "";
          const email = emailInput?.value.trim() || "";
          const notes = notesInput?.value.trim() || "";

          if (!ingredientName || ingredientName.length < 2) {
            if (messageBox) {
              messageBox.style.color = "red";
              messageBox.textContent = "Please enter an ingredient name.";
            }
            return;
          }

          try {
            const response = await fetch(INGREDIENT_REQUEST_API, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                ingredient: ingredientName,
                productSeenIn,
                email,
                notes
              })
            });

            const data = await response.json();
            console.log("Ingredient request response:", data);

            if (response.ok && data.success) {
              if (messageBox) {
                messageBox.style.color = "green";
                messageBox.textContent = "Thank you. Your request has been submitted.";
              }
              if (productInput) productInput.value = "";
              if (emailInput) emailInput.value = "";
              if (notesInput) notesInput.value = "";
            } else {
              console.error("Request failed", data);
              if (data.userErrors && data.userErrors.length) {
                console.error("Shopify userErrors:", data.userErrors);
                console.error("Shopify first error field:", data.userErrors[0].field);
                console.error("Shopify first error message:", data.userErrors[0].message);
              }
              if (messageBox) {
                messageBox.style.color = "red";
                messageBox.textContent = "Sorry, something went wrong. Please try again later.";
              }
            }
          } catch (err) {
            console.error("Request error", err);
            if (messageBox) {
              messageBox.style.color = "red";
              messageBox.textContent = "Network error. Please try again later.";
            }
          }
        });
      }

      return;
    }

    // There ARE matches: show ingredient cards
    results.innerHTML = matches
      .map((item) => {
        return `
          <a
            href="/pages/ingredients?ingredient=${item.slug}"
            style="text-decoration:none;color:inherit;"
          >
            <div class="ingredient-card">
              <div class="ingredient-title">
                ${item.name}
              </div>
              <p>${item.description}</p>
            </div>
          </a>
        `;
      })
      .join("");
  });

  // Category filter behaviour
  categoryPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      const category = pill.getAttribute("data-category");

      // Visually mark active pill
      categoryPills.forEach(p => p.classList.remove("is-active"));
      pill.classList.add("is-active");

      // Clear text search and traffic filter
      input.value = "";
      hero.classList.remove("search-active");
      activeTraffic = null;
      trafficPills.forEach(p => p.classList.remove("is-active"));

      // Decide which ingredients to show
      let matches;
      if (category === "our") {
        matches = ingredients.filter((ingredient) => ingredient.in_our_formulas);
      } else {
        matches = ingredients.filter(
          (ingredient) =>
            ingredient.category &&
            ingredient.category.toLowerCase() === category.toLowerCase()
        );
      }

      if (!matches.length) {
        results.innerHTML = `
          <div class="ingredient-empty">
            <h3>No ingredients found in this category yet.</h3>
            <p>Try another category or search by ingredient name.</p>
          </div>
        `;
        return;
      }

      results.innerHTML = matches
        .map((item) => {
          return `
            <a
              href="/pages/ingredients?ingredient=${item.slug}"
              style="text-decoration:none;color:inherit;"
            >
              <div class="ingredient-card">
                <div class="ingredient-title">
                  ${item.name}
                </div>
                <p>${item.description}</p>
              </div>
            </a>
          `;
        })
        .join("");
    });
  });

  // Traffic-light filter behaviour
  trafficPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      const traffic = pill.getAttribute("data-traffic");

      // Toggle active state
      if (activeTraffic === traffic) {
        activeTraffic = null;
        trafficPills.forEach(p => p.classList.remove("is-active"));
        results.innerHTML = "";
        return;
      }

      activeTraffic = traffic;

      // Visually mark active traffic pill
      trafficPills.forEach(p => p.classList.remove("is-active"));
      pill.classList.add("is-active");

      // Clear text search and category selection
      input.value = "";
      hero.classList.remove("search-active");
      categoryPills.forEach(p => p.classList.remove("is-active"));

      // Filter by traffic_light
      const matches = ingredients.filter(
        (ingredient) =>
          ingredient.traffic_light &&
          ingredient.traffic_light.toLowerCase() === traffic.toLowerCase()
      );

      if (!matches.length) {
        results.innerHTML = `
          <div class="ingredient-empty">
            <h3>No ingredients found for this rating yet.</h3>
            <p>Try another safety rating, category, or search by ingredient name.</p>
          </div>
        `;
        return;
      }

      results.innerHTML = matches
        .map((item) => {
          return `
            <a
              href="/pages/ingredients?ingredient=${item.slug}"
              style="text-decoration:none;color:inherit;"
            >
              <div class="ingredient-card">
                <div class="ingredient-title">
                  ${item.name}
                </div>
                <p>${item.description}</p>
              </div>
            </a>
          `;
        })
        .join("");
    });
  });
}

    function renderIngredient(ingredient) {
      const badgeClass = `badge-${ingredient.traffic_light}`;

      const suitedSkinTypes =
        ingredient.skin_types_suited?.join(", ") || "All";

      const cautionSkinTypes =
        ingredient.skin_types_caution?.join(", ") || "None noted";

      const benefits =
        ingredient.benefits?.map((b) => `<li>${b}</li>`).join("") || "";

      app.innerHTML = `
        <div class="ingredient-dashboard">
          <a class="ingredient-back" href="/pages/ingredients">
            ← Back to ingredient search
          </a>

          <div class="dashboard-hero">
            <div>
              <div class="dashboard-label">
                INGREDIENT
              </div>

              <h1 class="dashboard-title">
                ${ingredient.name}
              </h1>

              <p class="dashboard-description">
                ${ingredient.description}
              </p>
            </div>

            <div class="quality-panel">
              <div class="quality-label">
                SAFETY
              </div>

              <div class="ingredient-badge ${badgeClass}">
                ${ingredient.traffic_light.toUpperCase()}
              </div>
            </div>
          </div>

          ${
            ingredient.in_our_formulas
              ? `
                <div class="formula-card">
                  Used in our formulations
                </div>
              `
              : ""
          }

          <div class="dashboard-grid">
            <div class="dashboard-card">
              <div class="card-label">
                BENEFITS
              </div>
              <ul class="dashboard-list">
                ${benefits}
              </ul>
            </div>

            <div class="dashboard-card">
              <div class="card-label">
                SKIN COMPATIBILITY
              </div>
              <div class="meta-row">
                <span>Best For</span>
                <strong>${suitedSkinTypes}</strong>
              </div>
              <div class="meta-row">
                <span>Caution</span>
                <strong>${cautionSkinTypes}</strong>
              </div>
            </div>

            <div class="dashboard-card">
              <div class="card-label">
                SOURCE & ORIGIN
              </div>

              ${(() => {
                // Build general source label
                const generalSources = [];
                if (ingredient.can_be_plant) generalSources.push("plant-derived");
                if (ingredient.can_be_animal) generalSources.push("animal-derived");
                if (ingredient.can_be_synthetic) generalSources.push("synthetic");

                const generalSourceLabel = generalSources.length
                  ? generalSources.join(", ")
                  : (ingredient.origin_type || "Not specified");

                const plantSourceLabel = ingredient.plant_source || "Not specified";

                let ourUsageLabel = "Not currently used in our formulas";
                if (ingredient.in_our_formulas) {
                  if (ingredient.in_our_formulas_source === "plant") {
                    const specific = ingredient.in_our_formulas_plant_source
                      ? ` from ${ingredient.in_our_formulas_plant_source}`
                      : "";
                    const veganTag = ingredient.in_our_formulas_vegan ? " (vegan)" : "";
                    ourUsageLabel = `In our formulas: plant-derived${specific}${veganTag}`;
                  } else if (ingredient.in_our_formulas_source === "animal") {
                    ourUsageLabel = "In our formulas: animal-derived";
                  } else if (ingredient.in_our_formulas_source === "synthetic") {
                    ourUsageLabel = "In our formulas: synthetic-derived";
                  } else {
                    ourUsageLabel = "In our formulas";
                  }
                }

                return `
                  <div class="meta-row">
                    <span>Possible sources (in general)</span>
                    <strong>${generalSourceLabel}</strong>
                  </div>

                  <div class="meta-row">
                    <span>Plant source (in general)</span>
                    <strong>${plantSourceLabel}</strong>
                  </div>

                  <div class="meta-row">
                    <span>How we use it</span>
                    <strong>${ourUsageLabel}</strong>
                  </div>

                  ${
                    ingredient.is_ecocert
                      ? `<div class="meta-row">
                          <span>Certifications</span>
                          <strong>ECOCERT-approved</strong>
                        </div>`
                      : ""
                  }

                `;
              })()}
            </div>

            <div class="dashboard-card">
              <div class="card-label">
                CLASSIFICATION
              </div>
              <div class="meta-row">
                <span>Category</span>
                <strong>${ingredient.category || "General"}</strong>
              </div>
              <div class="meta-row">
                <span>Aliases</span>
                <strong>
                  ${ingredient.aliases?.join(", ") || "None"}
                </strong>
              </div>
            </div>
          </div>

          <div class="dashboard-wide-card">
            <div class="card-label">
              WHY WE RATE THIS ${ingredient.traffic_light.toUpperCase()}
            </div>
            <p>
              ${ingredient.traffic_reason}
            </p>
          </div>

          <div class="dashboard-wide-card">
            <div class="card-label">
              ADDITIONAL NOTES
            </div>
            <p>
              ${ingredient.notes || "No additional notes yet."}
            </p>

            ${
              ingredient.deep_dive
                ? `<div class="ingredient-deep-dive" style="margin-top:16px; white-space:pre-line;">
                    ${ingredient.deep_dive}
                  </div>`
                : ""
            }
          </div>
        </div>
      `;
    }
  } catch (error) {
    console.error(error);

    app.innerHTML = `
      <div style="color:red;padding:20px;">
        Error loading ingredient lookup
        <br><br>
        ${error.message}
      </div>
    `;
  }
});